type TProps = {
  title: string;
};
const NoItem = ({ title }: TProps) => {
  return <div className="text-gray-500" >{title}</div>;
};

export default NoItem;
